export const PERSON_FIELDS_TO_SEND = {
  name: 'first_name',
  surname: 'last_name',
  patronymic: 'middle_name',
  isPatronymicAbsent: 'is_middle_name_absent',
  sex: 'gender',
  birthdate: 'birthdate',
  changeName: 'name_changes',
  isNameChanged: 'change_name',
  changeNameDocIssuer: 'issued_by',
  isRegisteredInMoscow: 'is_registered_in_moscow',
};

export const DOCUMENT_FIELDS_TO_SEND = {
  type: 'type',
  number: 'number',
  issueDate: 'issued_at',
  issuer: 'issued_by',
  divisionCode: 'division_code',
  birthPlace: 'place_of_birth',
};

export const APPLICANT_FIELDS_TO_SEND = {
  email: 'email',
  phone: 'phone',
  snils: 'snils',
  married: 'married',
  livingTogether: 'is_living_together',
};

export const ADDRESS_FIELDS_TO_SEND = {
  area: 'area',
  district: 'district',
  settlement: 'settlement',
  street: 'street',
  house: 'house',
  ownership: 'ownership',
  building: 'building',
  structure: 'structure',
  flat: 'flat',
  isManualInput: 'is_manual_input',
  bti_building_code: 'bti_building_code',
  fiasId: 'fias_id',
  addressMatchWithApplicant: 'address_match',

  // check field names below for exists in state
  isServeByEirc: 'is_serve_by_eirc',
};

export const CHILD_FIELDS_TO_SEND = {
  bornInCurrentMarriage: 'is_born_in_current_marriage',
  isApplicantChild: 'is_applicant_child_from_prev_marriage',
  isSpouseChild: 'is_spouse_child_from_prev_marriage',
  confirmingDocs: 'document_confirming_of_homestay',
};

export const SECOND_PARENT_FIELDS_TO_SEND = {
  ...PERSON_FIELDS_TO_SEND,
  paternityRegisterDate: 'paternity_established_at',
  paternityRegisterNumber: 'paternity_certificate_number',
  deathdate: 'date_of_death',
  dateOfMarriage: 'date_of_marriage',
  dateOfDivorce: 'date_of_divorce',
  deathDocIssuer: 'certificate_issued_by',
  divorceDocIssuer: 'certificate_issued_by',
};

export enum ORGANIZATION_FIELDS_TO_SEND {
  institutionName = 'institution_name',
  isFoundInCatalog = 'is_found_in_catalog',
}

export const MARRIAGE_FIELDS_TO_SEND = {
  dateOfMarriage: 'date_of_marriage',
  marriageRecordNumber: 'act_number',
  marriageRecordHolder: 'act_issued_by',
};
